import { ROLES } from './frontEndTypes';
import { format } from 'date-fns';

export const isAuthorized = (userGroups: string[] | undefined, allowedGroups: ROLES[]) => {
  return allowedGroups.some((curr) => {
    return userGroups && userGroups.length && userGroups.includes(curr);
  });
};

export const classNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(' ');
};

export const toFirstUpperCase = (s: string) => {
  const firstLetter = s.charAt(0);
  const rest = s.substring(1);
  return firstLetter.toUpperCase() + rest.toLowerCase();
};

export const formatName = (s: string) => {
  return s
    .split(' ')
    .map((c) => {
      return toFirstUpperCase(c);
    })
    .join(' ');
};

export const formatNumberAsDollarAmount = (number: string | number) => {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(Number(number));
};

interface Request {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [k: string]: any;
}

export const getOpenApiInterceptor = (accessToken: string | undefined) => {
  return (req: Request): Request | Promise<Request> => {
    if (accessToken) {
      req.headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return req;
  };
};

export const formatDateForDisplay = (date: Date | string) => {
  try {
    return format(date, 'MMMM d, yyyy h:mm a zzzz');
  } catch (error) {
    console.error('Date formatting error:', error);
    return 'Invalid date';
  }
};

/**
 * Gets a cookie value by name
 * @param name - The name of the cookie
 * @returns The cookie value or null if not found
 */
export const getCookie = (name: string): string | null => {
  if (typeof document === 'undefined') {
    return null;
  }
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) {
    return parts.pop()?.split(';').shift() || null;
  }
  return null;
};
